import angular from "angular";

angular
    .module('Train', [])
    .service('Train', ['$http', function ($http) {

        function uri(key, path) {
            let link = '/control-panel/trains';
            if (key) {
                link += '/' + key;
            }
            if (path) {
                link += '/' + path;
            }
            return link;
        }

        this.getList = function (params) {
            return $http.get(uri(null, 'get-list'), {params: params});
        };

        this.update = function (key, params) {
            params['_method'] = 'PUT';
            return $http.post(uri(key), params);
        };

    }]);

export default 'Train';


// WEBPACK FOOTER //
// ./resources/assets/modules/trains-control/train.js